// src/data/higherStudiesData.js
export const higherStudiesData = {
  India: {
    "IIT Delhi": [
      "Computer Science",
      "Mechanical Engineering",
      "Civil Engineering",
      "Electrical Engineering",
      "Aerospace Engineering",
      "Data Science",
      "AI & Machine Learning",
      "Robotics",
      "Cyber Security",
      "Structural Engineering"
    ],
    "IIT Bombay": [
      "Computer Science",
      "Electronics & Communication",
      "Mathematics",
      "Physics",
      "Aerospace Engineering",
      "AI & Deep Learning",
      "Big Data Analytics",
      "Cloud Computing",
      "Biotechnology",
      "Machine Learning"
    ],
    "IIT Madras": [
      "AI & Data Science",
      "Electronics",
      "Civil Engineering",
      "Energy Engineering",
      "Mechanical Engineering",
      "Robotics",
      "Cyber Security",
      "Bioinformatics",
      "Chemical Engineering",
      "Applied Mathematics"
    ],
    "NIT Trichy": [
      "Computer Science",
      "Civil Engineering",
      "Mechanical Engineering",
      "Electrical Engineering",
      "Electronics & Communication",
      "AI & ML",
      "Robotics",
      "Internet of Things",
      "Automobile Engineering",
      "Cyber Security"
    ],
    "IISc Bangalore": [
      "Data Science",
      "AI & ML",
      "Biotechnology",
      "Cyber Security",
      "Aerospace Engineering",
      "Physics",
      "Applied Mathematics",
      "Robotics",
      "Mechanical Engineering",
      "Structural Engineering"
    ],
    "BITS Pilani": [
      "Computer Science",
      "Applied Mathematics",
      "Civil Engineering",
      "Electrical Engineering",
      "Biotechnology",
      "AI & ML",
      "IoT Engineering",
      "Cyber Security",
      "Mechanical Engineering",
      "Energy Engineering"
    ],
    "VIT Vellore": [
      "Computer Science",
      "Mechanical Engineering",
      "Civil Engineering",
      "Electrical Engineering",
      "AI & ML",
      "Robotics",
      "IoT",
      "Cyber Security",
      "Big Data",
      "Automobile Engineering"
    ],
    "SRM University": [
      "Computer Science",
      "AI & ML",
      "Cyber Security",
      "Mechanical Engineering",
      "Civil Engineering",
      "Electrical Engineering",
      "IoT",
      "Robotics",
      "Aerospace",
      "Biotechnology"
    ],
    "Anna University": [
      "Computer Science",
      "Civil Engineering",
      "Mechanical Engineering",
      "Electrical Engineering",
      "Electronics",
      "AI & ML",
      "IoT",
      "Robotics",
      "Biotechnology",
      "Energy Engineering"
    ],
    "JNTU Hyderabad": [
      "Computer Science",
      "AI & ML",
      "Civil Engineering",
      "Mechanical Engineering",
      "Electrical Engineering",
      "Data Science",
      "IoT",
      "Robotics",
      "Cyber Security",
      "Aerospace Engineering"
    ]
  },

  USA: {
    "MIT": [
      "Computer Science",
      "AI & Robotics",
      "Quantum Computing",
      "Cyber Security",
      "Data Science",
      "Mechanical Engineering",
      "Civil Engineering",
      "Aerospace Engineering",
      "Electrical Engineering",
      "Biotechnology"
    ],
    "Stanford University": [
      "Software Engineering",
      "Machine Learning",
      "Data Analytics",
      "Civil Engineering",
      "Mechanical Engineering",
      "Cyber Security",
      "Robotics",
      "Physics",
      "Mathematics",
      "Bioinformatics"
    ],
    "Harvard University": [
      "Information Systems",
      "AI",
      "Bioinformatics",
      "Business Analytics",
      "Civil Engineering",
      "Mechanical Engineering",
      "Physics",
      "Economics",
      "Law",
      "Political Science"
    ],
    "UC Berkeley": [
      "Computer Science",
      "Electrical Engineering",
      "AI & ML",
      "Data Science",
      "Civil Engineering",
      "Robotics",
      "Bioinformatics",
      "Economics",
      "Mathematics",
      "Aerospace Engineering"
    ],
    "UCLA": [
      "Computer Science",
      "Mechanical Engineering",
      "Civil Engineering",
      "Physics",
      "Data Science",
      "AI & ML",
      "Cyber Security",
      "Robotics",
      "Economics",
      "Biotechnology"
    ],
    "Carnegie Mellon University": [
      "Software Engineering",
      "Robotics",
      "AI & ML",
      "Data Science",
      "Cyber Security",
      "Civil Engineering",
      "Mechanical Engineering",
      "Electrical Engineering",
      "Mathematics",
      "Physics"
    ],
    "Princeton University": [
      "Mathematics",
      "Physics",
      "AI & ML",
      "Civil Engineering",
      "Mechanical Engineering",
      "Electrical Engineering",
      "Robotics",
      "Political Science",
      "Law",
      "Economics"
    ],
    "Yale University": [
      "Computer Science",
      "AI & ML",
      "Civil Engineering",
      "Mechanical Engineering",
      "Physics",
      "Law",
      "Economics",
      "Political Science",
      "Cyber Security",
      "Robotics"
    ],
    "Columbia University": [
      "Data Science",
      "AI & ML",
      "Civil Engineering",
      "Mechanical Engineering",
      "Physics",
      "Mathematics",
      "Economics",
      "Law",
      "Bioinformatics",
      "Political Science"
    ],
    "Caltech": [
      "Physics",
      "Mathematics",
      "Astronomy",
      "Computer Science",
      "AI & ML",
      "Robotics",
      "Mechanical Engineering",
      "Civil Engineering",
      "Electrical Engineering",
      "Aerospace Engineering"
    ]
  },

  UK: {
    "University of Oxford": [
      "Computer Science",
      "AI & ML",
      "Cyber Security",
      "Data Science",
      "Physics",
      "Mathematics",
      "Engineering Science",
      "Robotics",
      "Bioinformatics",
      "Civil Engineering"
    ],
    "University of Cambridge": [
      "Computer Science",
      "Engineering",
      "Machine Learning",
      "Mathematics",
      "Physics",
      "Robotics",
      "Civil Engineering",
      "Bioengineering",
      "Electrical Engineering",
      "AI"
    ],
    "Imperial College London": [
      "Civil Engineering",
      "Electrical Engineering",
      "Mechanical Engineering",
      "Robotics",
      "AI & Data Science",
      "Biomedical Engineering",
      "Chemical Engineering",
      "Aerospace Engineering",
      "Materials Science",
      "Computer Science"
    ],
    "UCL": [
      "Computer Science",
      "Data Science",
      "AI & ML",
      "Civil Engineering",
      "Mechanical Engineering",
      "Bioinformatics",
      "Biomedical Engineering",
      "Mathematics",
      "Physics",
      "Cyber Security"
    ],
    "London School of Economics": [
      "Economics",
      "Data Science",
      "Business Analytics",
      "Political Science",
      "Law",
      "Finance",
      "Management",
      "Statistics",
      "Public Policy",
      "Economic History"
    ],
    "University of Edinburgh": [
      "Computer Science",
      "AI & ML",
      "Robotics",
      "Data Science",
      "Civil Engineering",
      "Mechanical Engineering",
      "Bioinformatics",
      "Physics",
      "Mathematics",
      "Cyber Security"
    ],
    "King's College London": [
      "Biomedical Science",
      "Data Science",
      "AI",
      "Computer Science",
      "Psychology",
      "Law",
      "Business Analytics",
      "Chemistry",
      "Physics",
      "Mathematics"
    ],
    "University of Manchester": [
      "Computer Science",
      "Aerospace Engineering",
      "Civil Engineering",
      "Mechanical Engineering",
      "Data Science",
      "AI & ML",
      "Electrical Engineering",
      "Materials Science",
      "Robotics",
      "Bioengineering"
    ],
    "University of Warwick": [
      "Mathematics",
      "Computer Science",
      "Data Science",
      "Economics",
      "Management",
      "Physics",
      "Engineering",
      "AI",
      "Statistics",
      "Business Analytics"
    ],
    "University of Glasgow": [
      "Computer Science",
      "AI & ML",
      "Data Science",
      "Engineering",
      "Physics",
      "Mathematics",
      "Bioinformatics",
      "Robotics",
      "Civil Engineering",
      "Electrical Engineering"
    ]
  },

  Canada: {
    "University of Toronto": [
      "Computer Science",
      "Data Science",
      "AI & ML",
      "Electrical Engineering",
      "Mechanical Engineering",
      "Civil Engineering",
      "Robotics",
      "Bioinformatics",
      "Physics",
      "Mathematics"
    ],
    "University of British Columbia": [
      "Computer Science",
      "Data Science",
      "Civil Engineering",
      "Mechanical Engineering",
      "Electrical Engineering",
      "Environmental Engineering",
      "AI & ML",
      "Robotics",
      "Biotechnology",
      "Mathematics"
    ],
    "McGill University": [
      "Computer Science",
      "Biomedical Engineering",
      "AI & ML",
      "Data Science",
      "Physics",
      "Mathematics",
      "Electrical Engineering",
      "Mechanical Engineering",
      "Civil Engineering",
      "Bioinformatics"
    ],
    "University of Waterloo": [
      "Computer Science",
      "Software Engineering",
      "Data Science",
      "AI & ML",
      "Electrical Engineering",
      "Robotics",
      "Mathematics",
      "Physics",
      "Civil Engineering",
      "Mechanical Engineering"
    ],
    "University of Alberta": [
      "Computer Science",
      "Data Science",
      "AI & ML",
      "Petroleum Engineering",
      "Civil Engineering",
      "Mechanical Engineering",
      "Electrical Engineering",
      "Environmental Engineering",
      "Robotics",
      "Biotechnology"
    ],
    "McMaster University": [
      "Mechanical Engineering",
      "Biomedical Engineering",
      "Computer Science",
      "Data Science",
      "Civil Engineering",
      "Electrical Engineering",
      "AI",
      "Robotics",
      "Materials Science",
      "Mathematics"
    ],
    "University of Montreal": [
      "Computer Science",
      "AI & ML",
      "Data Science",
      "Mathematics",
      "Physics",
      "Robotics",
      "Electrical Engineering",
      "Civil Engineering",
      "Biomedical Engineering",
      "Bioinformatics"
    ],
    "Queen's University": [
      "Computer Science",
      "Engineering",
      "Data Science",
      "AI",
      "Mathematics",
      "Physics",
      "Civil Engineering",
      "Mechanical Engineering",
      "Business Analytics",
      "Robotics"
    ],
    "Simon Fraser University": [
      "Computer Science",
      "Data Science",
      "AI",
      "Software Engineering",
      "Electrical Engineering",
      "Mechanical Engineering",
      "Civil Engineering",
      "Robotics",
      "Environmental Engineering",
      "Mathematics"
    ],
    "University of Ottawa": [
      "Computer Science",
      "Data Science",
      "AI",
      "Civil Engineering",
      "Mechanical Engineering",
      "Electrical Engineering",
      "Biomedical Engineering",
      "Political Science",
      "Law",
      "Mathematics"
    ]
  },

  Australia: {
    "University of Melbourne": [
      "Computer Science",
      "Data Science",
      "AI & ML",
      "Electrical Engineering",
      "Mechanical Engineering",
      "Civil Engineering",
      "Robotics",
      "Bioinformatics",
      "Environmental Engineering",
      "Mathematics"
    ],
    "Australian National University": [
      "Physics",
      "Computer Science",
      "Data Science",
      "AI",
      "Mathematics",
      "Engineering",
      "Robotics",
      "Bioinformatics",
      "Civil Engineering",
      "Environmental Science"
    ],
    "University of Sydney": [
      "Computer Science",
      "AI & ML",
      "Data Science",
      "Civil Engineering",
      "Mechanical Engineering",
      "Electrical Engineering",
      "Bioinformatics",
      "Robotics",
      "Biomedical Engineering",
      "Mathematics"
    ],
    "University of Queensland": [
      "Computer Science",
      "Data Science",
      "AI",
      "Civil Engineering",
      "Environmental Engineering",
      "Mechanical Engineering",
      "Electrical Engineering",
      "Robotics",
      "Biotechnology",
      "Mathematics"
    ],
    "Monash University": [
      "Computer Science",
      "AI & ML",
      "Data Science",
      "Biotechnology",
      "Mechanical Engineering",
      "Civil Engineering",
      "Electrical Engineering",
      "Robotics",
      "Pharmaceutical Engineering",
      "Mathematics"
    ],
    "University of New South Wales": [
      "Computer Science",
      "Data Science",
      "AI & ML",
      "Civil Engineering",
      "Mechanical Engineering",
      "Electrical Engineering",
      "Robotics",
      "Biomedical Engineering",
      "Environmental Engineering",
      "Mathematics"
    ],
    "University of Western Australia": [
      "Computer Science",
      "Data Science",
      "AI",
      "Marine Engineering",
      "Civil Engineering",
      "Mechanical Engineering",
      "Electrical Engineering",
      "Robotics",
      "Environmental Science",
      "Mathematics"
    ],
    "University of Adelaide": [
      "Computer Science",
      "Data Science",
      "AI",
      "Civil Engineering",
      "Mechanical Engineering",
      "Electrical Engineering",
      "Robotics",
      "Biotechnology",
      "Environmental Engineering",
      "Mathematics"
    ],
    "RMIT University": [
      "Computer Science",
      "Data Science",
      "AI",
      "Design Computing",
      "Mechanical Engineering",
      "Civil Engineering",
      "Electrical Engineering",
      "Robotics",
      "Industrial Engineering",
      "Mathematics"
    ],
    "University of Wollongong": [
      "Computer Science",
      "Data Science",
      "AI",
      "Civil Engineering",
      "Mechanical Engineering",
      "Electrical Engineering",
      "Robotics",
      "Environmental Engineering",
      "Biomedical Engineering",
      "Mathematics"
    ]
  },

  Germany: {
    "TU Munich": [
      "Mechanical Engineering",
      "Electrical Engineering",
      "Computer Science",
      "Data Science",
      "AI & ML",
      "Aerospace Engineering",
      "Civil Engineering",
      "Robotics",
      "Materials Science",
      "Physics"
    ],
    "RWTH Aachen": [
      "Mechanical Engineering",
      "Electrical Engineering",
      "Computer Science",
      "Civil Engineering",
      "Aerospace Engineering",
      "Data Science",
      "Robotics",
      "Materials Science",
      "Chemical Engineering",
      "Physics"
    ],
    "Technical University of Berlin": [
      "Computer Science",
      "Engineering",
      "AI & ML",
      "Data Science",
      "Civil Engineering",
      "Electrical Engineering",
      "Robotics",
      "Urban Planning",
      "Materials Science",
      "Physics"
    ],
    "University of Stuttgart": [
      "Mechanical Engineering",
      "Automotive Engineering",
      "Computer Science",
      "Aerospace Engineering",
      "Data Science",
      "AI",
      "Electrical Engineering",
      "Robotics",
      "Civil Engineering",
      "Materials Science"
    ],
    "Karlsruhe Institute of Technology": [
      "Computer Science",
      "AI & ML",
      "Data Science",
      "Mechanical Engineering",
      "Electrical Engineering",
      "Civil Engineering",
      "Robotics",
      "Materials Science",
      "Physics",
      "Chemistry"
    ],
    "University of Freiburg": [
      "Computer Science",
      "Data Science",
      "AI",
      "Biotechnology",
      "Environmental Engineering",
      "Civil Engineering",
      "Mechanical Engineering",
      "Robotics",
      "Materials Science",
      "Physics"
    ],
    "Technical University of Darmstadt": [
      "Computer Science",
      "Electrical Engineering",
      "AI & ML",
      "Data Science",
      "Mechanical Engineering",
      "Civil Engineering",
      "Robotics",
      "Cyber Security",
      "Materials Science",
      "Physics"
    ],
    "University of Bonn": [
      "Mathematics",
      "Computer Science",
      "Physics",
      "Data Science",
      "AI",
      "Civil Engineering",
      "Mechanical Engineering",
      "Robotics",
      "Economics",
      "Chemistry"
    ],
    "University of Cologne": [
      "Economics",
      "Computer Science",
      "Data Science",
      "AI",
      "Business Analytics",
      "Civil Engineering",
      "Mechanical Engineering",
      "Robotics",
      "Mathematics",
      "Physics"
    ],
    "Leibniz University Hannover": [
      "Mechanical Engineering",
      "Electrical Engineering",
      "Computer Science",
      "Civil Engineering",
      "Data Science",
      "AI",
      "Robotics",
      "Materials Science",
      "Physics",
      "Architecture"
    ]
  },

  France: {
    "Sorbonne University": [
      "Mathematics",
      "Physics",
      "Computer Science",
      "Data Science",
      "AI & ML",
      "Biotechnology",
      "Chemistry",
      "Environmental Science",
      "Economics",
      "Philosophy"
    ],
    "École Polytechnique": [
      "Computer Science",
      "Mathematics",
      "Physics",
      "AI",
      "Data Science",
      "Aerospace Engineering",
      "Mechanical Engineering",
      "Civil Engineering",
      "Robotics",
      "Materials Science"
    ],
    "Université PSL": [
      "Physics",
      "Mathematics",
      "Computer Science",
      "Data Science",
      "AI",
      "Economics",
      "Biotechnology",
      "Chemistry",
      "Environmental Science",
      "Robotics"
    ],
    "Université Paris-Saclay": [
      "Computer Science",
      "Data Science",
      "AI",
      "Physics",
      "Mathematics",
      "Engineering",
      "Robotics",
      "Biotechnology",
      "Materials Science",
      "Economics"
    ],
    "INSA Lyon": [
      "Computer Science",
      "Mechanical Engineering",
      "Civil Engineering",
      "Electrical Engineering",
      "Robotics",
      "Aerospace Engineering",
      "Data Science",
      "AI",
      "Materials Science",
      "Environmental Engineering"
    ],
    "HEC Paris": [
      "Business Analytics",
      "Management",
      "Finance",
      "Data Science",
      "Economics",
      "Marketing",
      "Strategy",
      "Entrepreneurship",
      "Statistics",
      "Operations Research"
    ],
    "Université de Bordeaux": [
      "Computer Science",
      "Data Science",
      "AI",
      "Biotechnology",
      "Environmental Science",
      "Chemistry",
      "Physics",
      "Mathematics",
      "Economics",
      "Robotics"
    ],
    "Grenoble INP": [
      "Engineering",
      "Computer Science",
      "Data Science",
      "AI",
      "Electrical Engineering",
      "Mechanical Engineering",
      "Materials Science",
      "Civil Engineering",
      "Robotics",
      "Physics"
    ],
    "Université de Strasbourg": [
      "Biotechnology",
      "Computer Science",
      "Data Science",
      "AI",
      "Chemistry",
      "Physics",
      "Mathematics",
      "Environmental Science",
      "Robotics",
      "Materials Science"
    ],
    "Université Grenoble Alpes": [
      "Computer Science",
      "Data Science",
      "AI",
      "Physics",
      "Mechanical Engineering",
      "Civil Engineering",
      "Electrical Engineering",
      "Robotics",
      "Materials Science",
      "Environmental Engineering"
    ]
  },

  Japan: {
    "University of Tokyo": [
      "Computer Science",
      "Robotics",
      "AI & ML",
      "Data Science",
      "Electrical Engineering",
      "Mechanical Engineering",
      "Civil Engineering",
      "Materials Science",
      "Physics",
      "Bioengineering"
    ],
    "Kyoto University": [
      "Computer Science",
      "Physics",
      "Chemistry",
      "AI",
      "Data Science",
      "Mechanical Engineering",
      "Civil Engineering",
      "Electrical Engineering",
      "Robotics",
      "Biotechnology"
    ],
    "Osaka University": [
      "Computer Science",
      "AI & ML",
      "Data Science",
      "Mechanical Engineering",
      "Civil Engineering",
      "Electrical Engineering",
      "Robotics",
      "Chemistry",
      "Materials Science",
      "Biotechnology"
    ],
    "Tohoku University": [
      "Materials Science",
      "Electrical Engineering",
      "Mechanical Engineering",
      "Computer Science",
      "AI",
      "Data Science",
      "Robotics",
      "Civil Engineering",
      "Physics",
      "Bioengineering"
    ],
    "Nagoya University": [
      "Engineering",
      "Computer Science",
      "AI",
      "Data Science",
      "Mechanical Engineering",
      "Electrical Engineering",
      "Civil Engineering",
      "Robotics",
      "Physics",
      "Materials Science"
    ],
    "Hokkaido University": [
      "Computer Science",
      "Data Science",
      "AI",
      "Environmental Science",
      "Mechanical Engineering",
      "Civil Engineering",
      "Electrical Engineering",
      "Biotechnology",
      "Robotics",
      "Chemistry"
    ],
    "Waseda University": [
      "Computer Science",
      "AI & ML",
      "Data Science",
      "Mechanical Engineering",
      "Civil Engineering",
      "Electrical Engineering",
      "Robotics",
      "Business Analytics",
      "Economics",
      "Materials Science"
    ],
    "Keio University": [
      "Computer Science",
      "Data Science",
      "AI",
      "Robotics",
      "Mechanical Engineering",
      "Civil Engineering",
      "Electrical Engineering",
      "Economics",
      "Law",
      "Business Analytics"
    ],
    "Kobe University": [
      "Computer Science",
      "Data Science",
      "AI",
      "Mechanical Engineering",
      "Civil Engineering",
      "Electrical Engineering",
      "Robotics",
      "Materials Science",
      "Chemistry",
      "Physics"
    ],
    "Tokyo Institute of Technology": [
      "Computer Science",
      "Engineering",
      "AI",
      "Data Science",
      "Materials Science",
      "Robotics",
      "Mechanical Engineering",
      "Electrical Engineering",
      "Physics",
      "Aerospace Engineering"
    ]
  },

  Singapore: {
    "NUS": [
      "Computer Science",
      "Data Science",
      "AI & ML",
      "Electrical Engineering",
      "Mechanical Engineering",
      "Civil Engineering",
      "Robotics",
      "Bioinformatics",
      "Materials Science",
      "Business Analytics"
    ],
    "NTU": [
      "Computer Science",
      "AI & ML",
      "Data Science",
      "Electrical Engineering",
      "Mechanical Engineering",
      "Civil Engineering",
      "Environmental Engineering",
      "Robotics",
      "Bioengineering",
      "Materials Science"
    ],
    "SMU": [
      "Business Analytics",
      "Computer Science",
      "Data Science",
      "AI",
      "Economics",
      "Law",
      "Management",
      "Statistics",
      "Finance",
      "Marketing"
    ],
    "SUTD": [
      "Design & Technology",
      "Computer Science",
      "AI",
      "Data Science",
      "Robotics",
      "Engineering",
      "Materials Science",
      "Architecture",
      "Mathematics",
      "Systems Engineering"
    ],
    "Singapore Management University": [
      "Business Analytics",
      "Finance",
      "Computer Science",
      "Data Science",
      "AI",
      "Management",
      "Law",
      "Economics",
      "Statistics",
      "Marketing"
    ],
    "SIM University": [
      "Business",
      "Computer Science",
      "Data Science",
      "AI",
      "Finance",
      "Management",
      "Law",
      "Marketing",
      "Economics",
      "Statistics"
    ],
    "Nanyang Polytechnic": [
      "Engineering",
      "Computer Science",
      "AI",
      "Data Analytics",
      "Robotics",
      "Mechanical Engineering",
      "Civil Engineering",
      "Electrical Engineering",
      "Biotechnology",
      "Logistics"
    ],
    "Singapore Institute of Technology": [
      "Engineering",
      "Computer Science",
      "Data Science",
      "AI",
      "Robotics",
      "Mechanical Engineering",
      "Civil Engineering",
      "Biomedical Engineering",
      "Materials Science",
      "Environmental Engineering"
    ],
    "Lasalle College of the Arts": [
      "Design",
      "Creative Arts",
      "Digital Media",
      "Animation",
      "Photography",
      "Performing Arts",
      "Film",
      "Graphic Design",
      "Multimedia",
      "Fashion Design"
    ],
    "Republic Polytechnic": [
      "Engineering",
      "Computer Science",
      "Data Science",
      "AI",
      "Robotics",
      "Business",
      "Logistics",
      "Mechanical Engineering",
      "Civil Engineering",
      "Electrical Engineering"
    ]
  },

  UAE: {
    "Khalifa University": [
      "Petroleum Engineering",
      "Aerospace Engineering",
      "Computer Science",
      "Data Science",
      "AI & ML",
      "Mechanical Engineering",
      "Civil Engineering",
      "Electrical Engineering",
      "Robotics",
      "Materials Science"
    ],
    "United Arab Emirates University": [
      "Computer Science",
      "Data Science",
      "AI",
      "Mechanical Engineering",
      "Civil Engineering",
      "Electrical Engineering",
      "Environmental Engineering",
      "Robotics",
      "Petroleum Engineering",
      "Business Analytics"
    ],
    "Zayed University": [
      "Business",
      "Computer Science",
      "Media",
      "Design",
      "Data Science",
      "AI",
      "Education",
      "Management",
      "Marketing",
      "Finance"
    ],
    "American University of Sharjah": [
      "Architecture",
      "Engineering",
      "Computer Science",
      "Data Science",
      "AI",
      "Mechanical Engineering",
      "Civil Engineering",
      "Electrical Engineering",
      "Robotics",
      "Business"
    ],
    "American University in Dubai": [
      "Business",
      "Computer Science",
      "Data Science",
      "AI",
      "Marketing",
      "Finance",
      "Engineering",
      "Architecture",
      "Media",
      "Design"
    ],
    "University of Sharjah": [
      "Engineering",
      "Computer Science",
      "Data Science",
      "AI",
      "Civil Engineering",
      "Mechanical Engineering",
      "Electrical Engineering",
      "Robotics",
      "Architecture",
      "Business"
    ],
    "Heriot-Watt University Dubai": [
      "Engineering",
      "Computer Science",
      "Data Science",
      "AI",
      "Business",
      "Accounting",
      "Architecture",
      "Mechanical Engineering",
      "Civil Engineering",
      "Materials Science"
    ],
    "Middlesex University Dubai": [
      "Business",
      "Computer Science",
      "Data Science",
      "AI",
      "Law",
      "Marketing",
      "Finance",
      "Engineering",
      "Psychology",
      "Education"
    ],
    "University of Dubai": [
      "Business",
      "Computer Science",
      "Data Science",
      "AI",
      "Finance",
      "Accounting",
      "Management",
      "Engineering",
      "Law",
      "Marketing"
    ],
    "Canadian University Dubai": [
      "Business",
      "Engineering",
      "Computer Science",
      "Data Science",
      "AI",
      "Architecture",
      "Design",
      "Management",
      "Finance",
      "Communication"
    ]
  },

  SouthKorea: {
    "Seoul National University": [
      "Computer Science",
      "AI & ML",
      "Data Science",
      "Mechanical Engineering",
      "Civil Engineering",
      "Electrical Engineering",
      "Robotics",
      "Materials Science",
      "Physics",
      "Biotechnology"
    ],
    "KAIST": [
      "Computer Science",
      "Robotics",
      "AI",
      "Data Science",
      "Electrical Engineering",
      "Mechanical Engineering",
      "Aerospace Engineering",
      "Materials Science",
      "Chemistry",
      "Physics"
    ],
    "POSTECH": [
      "Materials Science",
      "Computer Science",
      "AI",
      "Data Science",
      "Mechanical Engineering",
      "Electrical Engineering",
      "Robotics",
      "Physics",
      "Chemistry",
      "Biotechnology"
    ],
    "Korea University": [
      "Computer Science",
      "Data Science",
      "AI",
      "Mechanical Engineering",
      "Civil Engineering",
      "Electrical Engineering",
      "Business Analytics",
      "Economics",
      "Law",
      "Robotics"
    ],
    "Yonsei University": [
      "Computer Science",
      "AI",
      "Data Science",
      "Mechanical Engineering",
      "Civil Engineering",
      "Electrical Engineering",
      "Robotics",
      "Business",
      "Economics",
      "Law"
    ],
    "Hanyang University": [
      "Computer Science",
      "Engineering",
      "AI",
      "Data Science",
      "Mechanical Engineering",
      "Civil Engineering",
      "Electrical Engineering",
      "Robotics",
      "Materials Science",
      "Physics"
    ],
    "Sungkyunkwan University": [
      "Computer Science",
      "AI",
      "Data Science",
      "Materials Science",
      "Mechanical Engineering",
      "Electrical Engineering",
      "Civil Engineering",
      "Robotics",
      "Physics",
      "Chemistry"
    ],
    "Ewha Womans University": [
      "Computer Science",
      "Data Science",
      "AI",
      "Biotechnology",
      "Chemistry",
      "Physics",
      "Mathematics",
      "Business",
      "Education",
      "Environmental Science"
    ],
    "Chung-Ang University": [
      "Computer Science",
      "AI",
      "Data Science",
      "Media",
      "Business",
      "Engineering",
      "Robotics",
      "Biotechnology",
      "Chemistry",
      "Physics"
    ],
    "Pohang University of Science and Technology": [
      "Materials Science",
      "Computer Science",
      "AI",
      "Data Science",
      "Physics",
      "Chemistry",
      "Engineering",
      "Robotics",
      "Mechanical Engineering",
      "Electrical Engineering"
    ]
  },

  Germany2: {
    // included an alternate grouping to reach 10 countries - you can rename keys if needed
    "University of Hamburg": [
      "Computer Science",
      "Data Science",
      "AI",
      "Logistics",
      "Maritime Engineering",
      "Mechanical Engineering",
      "Civil Engineering",
      "Business",
      "Economics",
      "Materials Science"
    ],
    "TU Dortmund": [
      "Computer Science",
      "Mechanical Engineering",
      "Electrical Engineering",
      "AI",
      "Data Science",
      "Civil Engineering",
      "Robotics",
      "Physics",
      "Materials Science",
      "Mathematics"
    ],
    "University of Bremen": [
      "Maritime Engineering",
      "Computer Science",
      "AI",
      "Data Science",
      "Physics",
      "Chemistry",
      "Mechanical Engineering",
      "Civil Engineering",
      "Environmental Science",
      "Materials Science"
    ],
    "University of Leipzig": [
      "Computer Science",
      "Mathematics",
      "Physics",
      "Data Science",
      "AI",
      "Economics",
      "Law",
      "Civil Engineering",
      "Mechanical Engineering",
      "Business"
    ],
    "TU Berlin2": [
      "Computer Science",
      "AI",
      "Data Science",
      "Civil Engineering",
      "Mechanical Engineering",
      "Electrical Engineering",
      "Robotics",
      "Architecture",
      "Urban Planning",
      "Materials Science"
    ],
    "University of Erlangen": [
      "Mechanical Engineering",
      "Electrical Engineering",
      "Computer Science",
      "AI",
      "Data Science",
      "Civil Engineering",
      "Robotics",
      "Materials Science",
      "Physics",
      "Chemistry"
    ],
    "University of Münster": [
      "Law",
      "Business",
      "Economics",
      "Computer Science",
      "Data Science",
      "AI",
      "Mathematics",
      "Physics",
      "Chemistry",
      "Biology"
    ],
    "University of Tübingen": [
      "Computer Science",
      "AI",
      "Data Science",
      "Neuroscience",
      "Mathematics",
      "Biology",
      "Chemistry",
      "Physics",
      "Engineering",
      "Philosophy"
    ],
    "Leuphana University": [
      "Sustainability",
      "Business",
      "Computer Science",
      "Data Science",
      "AI",
      "Environmental Science",
      "Law",
      "Economics",
      "Design",
      "Material Science"
    ],
    "University of Potsdam": [
      "Computer Science",
      "Data Science",
      "AI",
      "Mathematics",
      "Physics",
      "Psychology",
      "Economics",
      "Environmental Science",
      "Biology",
      "Chemistry"
    ]
  }
};
